<template>
    <div><img style="width:100%;" src="./wqx.jpg"/></div>
</template>

<script>
    export default {
        name: "error"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/error/error.vue